import React from "react";
import { map } from "lodash";
import { Image } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "./WhatWeOffer.css";

export const WhatWeOffer = ({ data, heading, subHeading }) => {
  return (
    <Overview
      title={heading}
      // desc={subHeading}
      data={data}
      count={4}
    />
  );
};

const Overview = ({ title, desc, data, count, bg }) => {
  return (
    <div
      className="destvisit standard-padding"
      style={{ backgroundColor: bg ? bg : "white" }}
    >
      {/* Heading */}
      <p className="heading" style={{ textAlign: "center" }}>
        {title}
      </p>

      {/* Sub Heading */}
      {desc && (
        <h4 className="subheading" style={{ textAlign: "center" }}>
          {desc}
        </h4>
      )}

      {/* DESKTOP VIEW (Grid Cards Layout) */}
      <div className="destvisit-container destvisit-desktop-view">
        {map(data, (d, index) => (
          <div key={index} className="destvisit-card">
            <div className="destvisit-card-container">
              <Image
                className="destvisit-card-img"
                src={d.image}
                alt={d.title || "image"}
              />

              <div className="destvisit-card-content">
                <h5 className="subheading subheading-whatweoffer">
                  {d.title}
                </h5>
                <p className="text Text-whatweoffer">{d.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* MOBILE VIEW (Swiper Slider) */}
      <div className="destvisit-mobile-view">
        <Swiper
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          spaceBetween={20}
          loop={true}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          className="whatweoffer-swiper"
        >
          {map(data, (d, index) => (
            <SwiperSlide key={index}>
              <div className="destvisit-card-container mobile-card-container">
                <Image
                  className="destvisit-card-img"
                  src={d.image}
                  alt={d.title || "image"}
                />

                <div className="destvisit-card-content">
                  <h5 className="subheading subheading-whatweoffer">
                    {d.title}
                  </h5>
                  <p className="text Text-whatweoffer">{d.desc}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};